import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/Default.vue").then(m => m.default || m)),
  personal: defineAsyncComponent(() => import("/usr/src/app/layouts/Personal.vue").then(m => m.default || m)),
  widget: defineAsyncComponent(() => import("/usr/src/app/layouts/Widget.vue").then(m => m.default || m)),
  "shared-access": defineAsyncComponent(() => import("/usr/src/app/layouts/shared-access.vue").then(m => m.default || m))
}